export const isOnelinkUrl = (url: string) => {
  return !!url.match(/(\.|\/\/)onelink\.com(\/|$)/i);
};
